module.exports = __webpack_public_path__ + "static/img/1.d000f62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/1.png
// module id = 5lAR
// module chunks = 0